import { Page } from '../models/Elements';
import { Plot } from '../models/Entities';
import dateService from '../services/DateService';
import { adminApiAxios } from './CustomAxios';

class PlotApi {
    list = async (page: number, size: number, sortField: string, sortOrder: boolean, companyId: number, searchText?: string): Promise<Page<Plot>> => {
        const response = await adminApiAxios.get<Page<Plot>>('/plots', {
            params: { page, size, sortField, sortOrder, companyId, searchText, status: 'ENABLED' }
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((user) => this.loadDates(user));

        return response.data;
    };

    get = async (plotId: number): Promise<Plot> => {
        const response = await adminApiAxios.get<Plot>(`/plots/${plotId}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (plot: Plot): Promise<Plot> => {
        const response = await adminApiAxios.post<Plot>(`/plots`, plot);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (plot: Plot): Promise<Plot> => {
        const response = await adminApiAxios.put<Plot>(`/plots/${plot.id}`, plot);
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (plotId: number): Promise<void> => {
        const response = await adminApiAxios.delete<void>(`/plots/${plotId}`);

        return response.data;
    };

    //TODO additional methods

    /* listDailyInsects = async (plotId: number): Promise<DateInsects[] | undefined> => {
        //TODO call trapImageApi.list filtered by plotId with size:1000
        const tempDailyInsects: DateInsects[] = mockTrapImages
            .filter((mti) => mti.plotId === plotId)
            .map((mti) => {
                return { date: mti.date.startOf('day'), insects: mti.insectsCount || 0 };
            });
        //create a dictionary-like object from this array
        const dailyInsectsDictionary: Dictionary<DateInsects[]> = _.groupBy(tempDailyInsects, 'date');
        const dailyInsects: DateInsects[] = Object.entries(dailyInsectsDictionary).map((di) => {
            return {
                date: dayjs(di[0]),
                insects: di[1].map((di) => di.insects).reduce((partialSum, a) => partialSum + a, 0)
            };
        });
        return Promise.resolve(dailyInsects);
    };
 */
    /**
     * Loads the dates of an plot.
     * @param plot - the plot
     */
    private loadDates(plot: Plot) {
        plot.audit!.created = dateService.transformDate(plot.audit!.created)!;
        plot.audit!.updated = dateService.transformDate(plot.audit!.updated)!;
    }
}

const plotApi: PlotApi = new PlotApi();
export default plotApi;
